import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from "../../images/services/HomeImprovement.webp";
import {IoBuild} from "react-icons/io5";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function HomeImprovementPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Home Improvement Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Discover top-notch home improvement services in Charlotte NC. From remodeling to repairs, our expert team delivers quality solutions tailored to your needs."
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><IoBuild className={classes.servicesIcon}/> {languageContext.services.HomeImprovementPage.title}</h1>
                <p className={classes.darkText}>{languageContext.services.HomeImprovementPage.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.HomeImprovementPage.text1}
                            <br/><br/>
                            <span>{languageContext.services.HomeImprovementPage.text2}</span>
                            <br/>
                            {languageContext.services.HomeImprovementPage.text3}
                            <br/><br/>
                            <span>{languageContext.services.HomeImprovementPage.text4}</span>
                            <br/>
                            {languageContext.services.HomeImprovementPage.text5}
                            <br/><br/>
                            <span>{languageContext.services.HomeImprovementPage.text6}</span>
                            <br/>
                            {languageContext.services.HomeImprovementPage.text7}
                            <br/><br/>
                            <span>{languageContext.services.HomeImprovementPage.text8}</span>
                            <br/>
                            {languageContext.services.HomeImprovementPage.text9}
                            <br/><br/>
                            <span>{languageContext.services.HomeImprovementPage.text10}</span>
                            <br/>
                            {languageContext.services.HomeImprovementPage.text11}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.image}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default HomeImprovementPage;